/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentEditorsScholarshipTypes200,
  GetApiV1IndividualpaymentEditorsScholarshipTypes401,
  GetApiV1IndividualpaymentEditorsScholarshipTypes500,
  GetApiV1IndividualpaymentEditorsScholarshipTypesQueryParams,
  GetApiV1IndividualpaymentEditorsScholarshipTypesQueryResponse,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsScholarshipTypes.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1IndividualpaymentEditorsScholarshipTypesQueryParamsSchema =
  z
    .object({
      companyId: z.optional(z.coerce.number().int()),
      scholarshipTypeId: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1IndividualpaymentEditorsScholarshipTypesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentEditorsScholarshipTypes200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1IndividualpaymentEditorsScholarshipTypes200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentEditorsScholarshipTypes401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentEditorsScholarshipTypes401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentEditorsScholarshipTypes500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentEditorsScholarshipTypes500>;

export const getApiV1IndividualpaymentEditorsScholarshipTypesQueryResponseSchema =
  z.lazy(
    () => getApiV1IndividualpaymentEditorsScholarshipTypes200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentEditorsScholarshipTypesQueryResponse>;
